export enum PartyTypeEnum {
  PERSON = 'PERSON',
  INSTITUTION = 'COMPANY'
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}
